export default (state = {}, {errorCode}) => {
  if (!errorCode) return state;

  return {
    ...state,
    [errorCode]: true,
  };
};
